import {css} from 'styled-components';
import {media} from './responsive';

export const withBoxSize = ({Width, Height, smWidth, mdWidth, lgWidth}) => {

    return css`
        ${Width && `width: ${Width};`} 
        ${Height && `height: ${Height};`} 
  `
}

export const withCenters = ({center, vCenter, hCenter}) => {

    if (center)
        return css`
          display: flex;
          justify-content: center;
          align-items: center;
    `

    if (vCenter)
        return css`
          display: flex;
          align-items: center;
    `
    if (hCenter)
        return css`
          display: flex;
           justify-content: center;
    `
    return ''
}

export const getPaletteColorByTypeTheme = (theme, type) => {
    if (theme && theme.palette) {
        return theme.palette[type] || theme.palette.default;
    }
}

export const withColorByPallet = ({theme, type}) => {

    return css`
        ${type && `color: ${getPaletteColorByTypeTheme(theme, type)};`} 
  `
}

export const withBGColorByPallet = ({theme, type}) => {

    return css`
        ${type && `background-color: ${getPaletteColorByTypeTheme(theme, type)};`} 
  `
}


function getWidthString(value) {
    if (!value) return
    let width = value / 12 * 100
    return `flex: 0 0 ${width}%; max-width: ${width}%;`;

}

export const withBootrapGrid = ({xs, sm, md, lg, row}) => {
    return css`
            ${row && `display: flex;
                    flex-wrap: wrap;
                    margin-right: -15px;
                    margin-left: -15px;`
        };
            ${(xs ? `padding: 0 15px;` + getWidthString(xs) : '')};
            ${media.tablet`${(sm && `padding: 0 15px;` + getWidthString(sm))}`};
            ${media.desktop`${(md && `padding: 0 15px;` + getWidthString(md))}`};
            ${media.giant`${(lg && `padding: 0 15px;` + getWidthString(lg))};`}
  `
}


